import { gql } from "@apollo/client";

export const UPDATE_GEOLOCATION = gql`
  mutation updateLocation($input: UpdateLocationInput!) {
    updateLocation(input: $input) {
      clientMutationId
      errors
      officer {
        id
      }
    }
  }
`;
